import * as React from "react";
import {Field} from "react-final-form";
import Select, { components } from "react-select";

export default class TextoInputSelector extends React.Component<TextoInputSelectorProps, any> {

    render() {
        const {name, maestro} = this.props;
        return (
            <Field name={name}
                   component={this.ReactContenidoSelector}
                   options={maestro}
            />
        ); 
    }

    ReactContenidoSelector = ({ input, ...rest }) => {
        const estiloPersonalizado = {
            container: (base) => ({
                ...base,
                height: '30px'
            }),
            control: (base, state) => ({
                ...base,
                height: '35px',
                minHeight: '35px',
                background: '#FFF',
                borderRadius: '1px',
                border: state.isFocused ? '1px solid #00AEC7' : '1px solid #CCC',
                boxShadow: state.isFocused ? '0px 0px 3px 0px rgba(0,174,199,1)' : 'none', 
                '&:hover': {
                    borderColor: state.isFocused ? '#00AEC7' : 'inner'
                },
                marginTop: '-1px',
                fontFamily: 'Arial',
                fontSize: '14px',
                color: '#555'
            }),
            menu: (base) => ({
                ...base,
                borderRadius: 'none',
                hyphens: 'auto',
                marginTop: '1px',
                textAlign: 'left'
            }),
            indicatorSeparator: (base) => ({
                ...base,
                display: 'true'
            }),
            dropdownIndicator: (base) => ({
                ...base,
                color: '#555',
                width: '92%',
                marginRight: '0px'
            }),
            placeholder: (base) => ({
                ...base,
                fontFamily: 'Arial',
                fontSize: '14px',
                color: '#555',
                marginTop: '-1px',
            }),
            option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused ? '#1E90FF' : '#FFF',
                color: state.isFocused ? "#FFF" : '#555',
                fontSize: '15px',
                fontFamily: 'Roboto, sans-serif'
            }),
            noOptionsMessage: (base) => ({
                ...base,
                fontSize: '15px',
                fontFamily: 'Roboto, sans-serif'
            })
        };
        return (
            <Select {...input} {...rest}
                isClearable
                isMulti={this.props.selectorMultiple ? this.props.selectorMultiple : false}
                placeholder="Ingresa..."
                noOptionsMessage={() => "Sin Resultados"}
                styles={estiloPersonalizado}
                components={{
                    Menu: (props) => <components.Menu {...props} className="menu-selection" />
                }}
            />
        );
    };
}

interface TextoInputSelectorProps {
    name: string,
    maestro: any,
    selectorMultiple?: boolean
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/TextoInputSelector.tsx